import { render, staticRenderFns } from "./MultipleChoiceImageConfig.vue?vue&type=template&id=704c3d36"
import script from "./MultipleChoiceImageConfig.vue?vue&type=script&lang=js"
export * from "./MultipleChoiceImageConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704c3d36')) {
      api.createRecord('704c3d36', component.options)
    } else {
      api.reload('704c3d36', component.options)
    }
    module.hot.accept("./MultipleChoiceImageConfig.vue?vue&type=template&id=704c3d36", function () {
      api.rerender('704c3d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/MultipleChoiceImageConfig.vue"
export default component.exports